import { Dispatch } from 'redux';

const saveGridData = (tableName: string) => (dataType: string, data?: any[]) => (dispatch: Dispatch) => {
    dispatch({ type: `${tableName}/${dataType}`, payload: data });
};

export const getGridAction = (tableName: string) => saveGridData(tableName);
